import type { FundingAssignedOperatorNew } from "./FundingAssignedOperatorNew";
import type { FileFunding } from "./FileFunding";

export enum StepFundingResponseStatus {
    "CREATED" = "CREATED",
    "PROCESSING" = "PROCESSING",
    "WAITING_CADASTRAL_NUMBERS" = "WAITING_CADASTRAL_NUMBERS",
    "WAITING_PRELIMINARY_LIMIT" = "WAITING_PRELIMINARY_LIMIT",
    "AGREEING_PRELIMINARY_LIMIT" = "AGREEING_PRELIMINARY_LIMIT",
    "DOCUMENT_COLLECTION" = "DOCUMENT_COLLECTION",
    "WAITING_FINAL_DECISION" = "WAITING_FINAL_DECISION",
    "FINAL_TERMS_AGREEMENT" = "FINAL_TERMS_AGREEMENT",
    "CLIENT_DEAL_PREPARATION" = "CLIENT_DEAL_PREPARATION",
    "SIGNING_OF_MKK" = "SIGNING_OF_MKK",
    "SIGNING_OF_CLIENT" = "SIGNING_OF_CLIENT",
    "COLLATERAL_REGISTRATION" = "COLLATERAL_REGISTRATION",
    "LIMIT_DRAWDOWN_MONITORING" = "LIMIT_DRAWDOWN_MONITORING",
    "LIMIT_ISSUED_MONITORING" = "LIMIT_ISSUED_MONITORING",
    "COLLATERAL_RELEASE" = "COLLATERAL_RELEASE",
    "CONTRACT_CLOSED" = "CONTRACT_CLOSED"
}
export type StepFundingResponse = {
    /**
     * @type string
    */
    status: StepFundingResponseStatus;
    assignedOperator: FundingAssignedOperatorNew;
    loanContract?: FileFunding;
    mortgageContract?: FileFunding;
    /**
     * @type array | undefined
    */
    loanApplications?: FileFunding[];
    /**
     * @type boolean | undefined
    */
    canCreateAccreditations?: boolean;
};
